import axios from 'axios';
import { loginService } from './LoginService';

export const importService={
    importProducts,
    importProductsWithStream,
    importReceipts,
    importReceiptsWithStream
}
function importProducts(fileInfo) {
    let url = `${process.env.REACT_APP_API_URL}/api/products/import`;
 
    const requestOptionsPost = {
        method: 'POST',
        url,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        data:createBodyRequest(fileInfo)
      };
      if (loginService.loggedIn()) {
        requestOptionsPost.headers['Authorization'] = loginService.getToken();
      }
 
      return axios(requestOptionsPost);
  }

async function importProductsWithStream(fileInfo, handlers = {}) {
    const { onEvent, onDone, onError, signal } = handlers;
    const url = `${process.env.REACT_APP_API_URL}/api/products/import?stream=true`;
    const headers = {
      Accept: 'text/event-stream'
    };

    if (loginService.loggedIn()) {
      headers.Authorization = loginService.getToken();
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: createBodyRequest(fileInfo),
        signal
      });

      if (!response.ok) {
        let errorPayload = null;
        try {
          errorPayload = await response.json();
        } catch (_) {
          errorPayload = { message: `Import request failed with status ${response.status}` };
        }

        const streamingError = new Error(errorPayload?.message || 'Failed to import products.');
        streamingError.response = { status: response.status, data: errorPayload };
        throw streamingError;
      }

      if (!response.body) {
        const result = await response.json();
        if (onDone) onDone(result);
        return result;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let latestPayload = null;

      const parseEventChunk = (chunk) => {
        const lines = chunk.split(/\r?\n/);
        let eventName = 'message';
        const dataLines = [];

        lines.forEach((line) => {
          const normalizedLine = line.trimStart();
          if (normalizedLine.startsWith('event:')) {
            eventName = normalizedLine.slice(6).trim();
          }
          if (normalizedLine.startsWith('data:')) {
            dataLines.push(normalizedLine.slice(5).trim());
          }
        });

        if (!dataLines.length) return null;

        const rawData = dataLines.join('\n');
        let parsedData = rawData;

        try {
          parsedData = JSON.parse(rawData);
        } catch (_) {
          parsedData = rawData;
        }

        return { event: eventName, data: parsedData, raw: rawData };
      };

      try {
        // Read server-sent events until stream ends.
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const chunks = buffer.split(/\r?\n\r?\n/);
          buffer = chunks.pop() || '';

          chunks.forEach((eventChunk) => {
            const parsedEvent = parseEventChunk(eventChunk.trim());
            if (!parsedEvent) return;
            latestPayload = parsedEvent.data;
            if (onEvent) onEvent(parsedEvent);
          });
        }

        if (buffer.trim().length > 0) {
          const parsedEvent = parseEventChunk(buffer.trim());
          if (parsedEvent) {
            latestPayload = parsedEvent.data;
            if (onEvent) onEvent(parsedEvent);
          }
        }
      } finally {
        try {
          await reader.cancel();
        } catch (_) {
          // Reader may already be closed; safe to ignore.
        }
        if (typeof reader.releaseLock === 'function') {
          reader.releaseLock();
        }
      }

      if (onDone) onDone(latestPayload);
      return latestPayload;
    } catch (error) {
      if (error?.name === 'AbortError') {
        return null;
      }
      if (onError) onError(error);
      throw error;
    }
}

async function importReceiptsWithStream(fileInfo, handlers = {}) {
    const { onEvent, onDone, onError, signal } = handlers;
    const url = `${process.env.REACT_APP_API_URL}/api/receipts/bulk_import?stream=true`;
    const headers = {
      Accept: 'text/event-stream'
    };

    if (loginService.loggedIn()) {
      headers.Authorization = loginService.getToken();
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: createBodyReceiptRequest(fileInfo),
        signal
      });

      if (!response.ok) {
        let errorPayload = null;
        try {
          errorPayload = await response.json();
        } catch (_) {
          errorPayload = { message: `Import request failed with status ${response.status}` };
        }

        const streamingError = new Error(errorPayload?.message || 'Failed to import receipts.');
        streamingError.response = { status: response.status, data: errorPayload };
        throw streamingError;
      }

      if (!response.body) {
        const result = await response.json();
        if (onDone) onDone(result);
        return result;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let latestPayload = null;

      const parseEventChunk = (chunk) => {
        const lines = chunk.split(/\r?\n/);
        let eventName = 'message';
        const dataLines = [];

        lines.forEach((line) => {
          const normalizedLine = line.trimStart();
          if (normalizedLine.startsWith('event:')) {
            eventName = normalizedLine.slice(6).trim();
          }
          if (normalizedLine.startsWith('data:')) {
            dataLines.push(normalizedLine.slice(5).trim());
          }
        });

        if (!dataLines.length) return null;

        const rawData = dataLines.join('\n');
        let parsedData = rawData;

        try {
          parsedData = JSON.parse(rawData);
        } catch (_) {
          parsedData = rawData;
        }

        return { event: eventName, data: parsedData, raw: rawData };
      };

      try {
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const chunks = buffer.split(/\r?\n\r?\n/);
          buffer = chunks.pop() || '';

          chunks.forEach((eventChunk) => {
            const parsedEvent = parseEventChunk(eventChunk.trim());
            if (!parsedEvent) return;
            latestPayload = parsedEvent.data;
            if (onEvent) onEvent(parsedEvent);
          });
        }

        if (buffer.trim().length > 0) {
          const parsedEvent = parseEventChunk(buffer.trim());
          if (parsedEvent) {
            latestPayload = parsedEvent.data;
            if (onEvent) onEvent(parsedEvent);
          }
        }
      } finally {
        try {
          await reader.cancel();
        } catch (_) {
          // Reader may already be closed; safe to ignore.
        }
        if (typeof reader.releaseLock === 'function') {
          reader.releaseLock();
        }
      }

      if (onDone) onDone(latestPayload);
      return latestPayload;
    } catch (error) {
      if (error?.name === 'AbortError') {
        return null;
      }
      if (onError) onError(error);
      throw error;
    }
}
 
  
  function createBodyRequest(fileInfo) {
    let formData = new FormData();
    const document = fileInfo.file;

    if (document) {
        formData.append('file', document);
    }

    return formData;
}
function importReceipts(fileInfo) {
    let url = `${process.env.REACT_APP_API_URL}/api/receipts/bulk_import`;

    const requestOptionsPost = {
        method: 'POST',
        url,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
        data: createBodyReceiptRequest(fileInfo),
    };

    if (loginService.loggedIn()) {
        requestOptionsPost.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptionsPost);
}
  function createBodyReceiptRequest(fileInfo) {
    let formData = new FormData();

    if (fileInfo.file) {
        formData.append('file', fileInfo.file);
    } else if (fileInfo.files && Array.isArray(fileInfo.files)) {
        fileInfo.files.forEach((file) => {
            formData.append('files', file);
        });
    }

    return formData;
}